import { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import { sharedServices } from "../../APIServices/PasswordManagement/sharedServices";
import { decryptGroupKey, encryptGroupKey, encryptSharedKey, generateNewKey } from "../../APIHelpers/utils";
import { useApp } from "../../APIHelpers/AppContext";
import { TbUserShare } from "react-icons/tb";
import { FaPlusSquare, FaTrashAlt } from "react-icons/fa";
import { userServices } from "../../APIServices/UserData/userServices";
import { FiSearch } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { handleResponse } from "../../APIHelpers/Responses";
import { IoIosSend } from "react-icons/io";

const GroupShareWithMember = ({
  Show,
  Hide,
  Title,
  groupId,
  isDark,
  groupData,
  auth,
  currentUserData
}) => {
  const { getVaultKey } = useApp();
  const [shareWith, setShareWith] = useState("member");
  const [assignedMember, setAssignedMember] = useState([]);
  const [emails, setEmails] = useState([]);
  const [expiryTime, setExpiryTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");
  const [loader, setLoader] = useState(false);

  const [searchMember, setSearchMember] = useState("");
  const [members, setMembers] = useState([]);
  const [memberCount, setMemberCount] = useState(0);

  const getMembers = async () => {
    let data = await userServices.getMembers(auth, "active", searchMember);
    setMembers(data?.data || []);
    setMemberCount(data?.count)
  };

  const validateDuplicateEmails = (list) => {
    const countMap = {};

    list.forEach(item => {
      const key = item.email.trim().toLowerCase();
      if (!key) return;
      countMap[key] = (countMap[key] || 0) + 1;
    });

    return list.map(item => {
      const key = item.email.trim().toLowerCase();
      if (key && countMap[key] > 1) {
        return { ...item, error: "Duplicate Email, Please remove it" };
      }
      return { ...item, error: "" };
    });
  };

  const handleChange = (index, value) => {
    setEmails(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], email: value };
      return validateDuplicateEmails(updated);
    });
  };

  const handleAdd = () => {
    setEmails(prev => [...prev, { email: "", userId: "", publicKey: "", error: "" }]);
  };

  const handleDelete = (email) => {
    setEmails(prev =>
      prev.filter(item => item.email !== email)
    );
  };

  const shareGroupInternalUser = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to share of selected members?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, share it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let totalSharedKeys = []
        const sharedAt = new Date();
        for (const element of assignedMember) {
          let sharedKey = await generateNewKey()
          let encryptedSharedKey = await encryptSharedKey(sharedKey, element?.publicKey)
          let decryptedGroupKey = await decryptGroupKey(groupData?.groupKey, groupData?.groupKeyIV, getVaultKey())
          let { encryptedGroupKey, groupKeyIV } = await encryptGroupKey(decryptedGroupKey, sharedKey)
          const objectData = {
            scope: "group",
            isRevoked: false,
            sharedWith: element?.userId,
            sharedKey: encryptedSharedKey,
            groupKey: encryptedGroupKey,
            groupKeyIV: groupKeyIV,
            expiryAt: new Date(expiryTime),
            sharedAt: sharedAt,
          };
          totalSharedKeys.push(objectData)
        }
        let userData = {
          sharedId: Math.random().toString().substr(2, 10),
          groupId: groupId,
          adminId: groupData?.adminId,
          accountId: groupData?.accountId,
          sharedBy: currentUserData?.userId,
          sharedKeys: totalSharedKeys,
        }
        let data = await sharedServices.shareGroupInternalUser(auth, userData)
        if (data?.statusCode === 200) {
          setExpiryTime("");
          setAssignedMember([])
          Hide()
        }
        setLoader(false)
      }
    });
  };

  const checkRegistredUser = async (emails) => {
    let data = await userServices.checkRegistredUser(auth, { emails })
    setEmails(data?.data || [])
    return data?.data || []
  }

  const sendNotificationForRegistration = async (email) => {
    let data = await userServices.sendNotificationForRegistration(auth, { email })
    if (data?.statusCode === 200) {
      setEmails(prev =>
        prev.filter(item => item.email !== email)
      );
    }
  }

  const shareGroupExternalUser = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to share of this emails?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, share it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let totalEmails = await checkRegistredUser(emails)
        let checkTotalEmail = totalEmails.some(item => item.error || !item.email?.trim())
        if (checkTotalEmail) {
          setLoader(false);
          handleResponse({
            statusCode: 400,
            customMessage: "Email not registred, Please sent Notification for registration"
          })
        } else {
          let totalSharedKeys = []
          const sharedAt = new Date();
          for (const element of totalEmails) {
            let sharedKey = await generateNewKey()
            let encryptedSharedKey = await encryptSharedKey(sharedKey, element?.publicKey)
            let decryptedGroupKey = await decryptGroupKey(groupData?.groupKey, groupData?.groupKeyIV, getVaultKey())
            let { encryptedGroupKey, groupKeyIV } = await encryptGroupKey(decryptedGroupKey, sharedKey)
            const objectData = {
              scope: "group",
              isRevoked: false,
              sharedWith: element?.userId,
              sharedKey: encryptedSharedKey,
              groupKey: encryptedGroupKey,
              groupKeyIV: groupKeyIV,
              expiryAt: new Date(expiryTime),
              sharedAt: sharedAt,
            };
            totalSharedKeys.push(objectData)
          }
          let userData = {
            sharedId: Math.random().toString().substr(2, 10),
            groupId: groupId,
            adminId: groupData?.adminId,
            accountId: groupData?.accountId,
            sharedBy: currentUserData?.userId,
            sharedKeys: totalSharedKeys,
          }
          let data = await sharedServices.shareGroupInternalUser(auth, userData)
          if (data?.statusCode === 200) {
            setExpiryTime("");
            setEmails([])
            Hide()
          }
          setLoader(false)
        }
      }
    });
  };

  useEffect(() => {
    setAssignedMember(groupData?.assignedUser || [])
  }, [groupData]);

  const toggleMember = (userId) => {
    const member = members.find((m) => m.userId === userId);
    if (!member) return;
    setAssignedMember((prev) => {
      const exists = prev.find((p) => p.userId === userId);
      if (exists) {
        return prev.filter((p) => p.userId !== userId);
      } else {
        return [...prev, { userId: member.userId, publicKey: member.publicKey }];
      }
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const all = members.map((m) => ({ userId: m.userId, publicKey: m.publicKey }));
      setAssignedMember(all);
    } else {
      setAssignedMember([]);
    }
  };

  const RadioCard = ({ icon, label, active, onClick }) => (
    <div
      onClick={onClick}
      className={`p-2 rounded-2 border CP mb-2 w-100 text-center ${active ? "border-primary bg-primary bg-opacity-10" : "border-secondary"}`}
      style={{ fontSize: 12, fontWeight: 600 }}
    >
      {icon} {label}
    </div>
  );

  const getNowLocalDateTime = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    return new Date(now - offset).toISOString().slice(0, 16);
  };

  const handleExpiryChange = (e) => {
    const selectedValue = e.target.value;
    const selectedDate = new Date(selectedValue);
    const now = new Date();
    if (selectedDate < now) {
      setExpiryTime(getNowLocalDateTime());
      return;
    }
    setExpiryTime(selectedValue);
  };

  useEffect(() => {
    const updateTime = () => {
      const nowLocal = getNowLocalDateTime();
      setMinDateTime(nowLocal);
      setExpiryTime(prev =>
        prev && prev < nowLocal ? nowLocal : prev
      );
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (Show) {
      getMembers();
    }
  }, [auth, searchMember, groupId]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Share with <span className="text-danger">*</span>
          </Form.Label>
          <div className="hstack gap-2">
            <RadioCard
              icon={<TbUserShare className="me-1" />}
              label="Share with Members"
              active={shareWith === "member"}
              onClick={() => setShareWith("member")}
            />
            <RadioCard
              icon={<MdOutlineEmail className="me-1" />}
              label="Share with Anyone"
              active={shareWith === "anyone"}
              onClick={() => setShareWith("anyone")}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Expiry Time
          </Form.Label>
          <Form.Control
            type="datetime-local"
            value={expiryTime}
            min={minDateTime}
            onChange={handleExpiryChange}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 10px" }}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          {shareWith === "member" && (
            <>
              <Form.Group className="mb-3 position-relative">
                <FiSearch className="position-absolute" style={{ top: 8, left: 10, zIndex: 99 }} />
                <Form.Control
                  type="search"
                  onChange={(e) => setSearchMember(e.target.value)}
                  value={searchMember}
                  disabled={memberCount === 0}
                  placeholder="Search Member Here..."
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px 6px 35px" }}
                />
              </Form.Group>
              {members?.length > 0 && (
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  checked={assignedMember.length === members.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  style={{ fontSize: 12 }}
                  className="mb-2"
                />
              )}
              <div className="d-grid gap-2">
                {members?.map((m) => (
                  <div
                    key={m.userId}
                    onClick={() => toggleMember(m.userId)}
                    className={`CP hstack gap-1`}
                    style={{ fontSize: 12, cursor: "pointer" }}
                  >
                    <span className="text-primary">
                      <Form.Check
                        type="checkbox"
                        checked={assignedMember.some((p) => p.userId === m.userId)}
                        readOnly
                      />
                    </span>
                    {m.name}
                  </div>
                ))}
              </div>
            </>
          )}

          {shareWith === "anyone" && (
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1 hstack gap-2" style={{ fontSize: 13 }}>
                Emails
                <FaPlusSquare title="Add Email" size={13} className="CP" onClick={handleAdd} />
              </Form.Label>

              {emails.map((item, index) => (
                <div key={index} className="mb-2">
                  <div className="hstack gap-2">
                    <Form.Control
                      value={item.email}
                      placeholder={`Enter Email ${index + 1}`}
                      onChange={(e) => handleChange(index, e.target.value)}
                      className="interactive-input rounded-1"
                      isInvalid={!!item.error}
                      style={{ fontSize: 12, padding: "6px 15px" }}
                    />
                    {item?.error === "Email not registred, Please sent Notification for registration" ?
                      <IoIosSend
                        className="text-primary CP"
                        style={{ fontSize: 16 }}
                        title="Send Mail"
                        onClick={() => sendNotificationForRegistration(item.email)}
                      />
                      :
                      <FaTrashAlt
                        className="text-danger CP"
                        style={{ fontSize: 14 }}
                        title="Delete Email"
                        onClick={() => handleDelete(item.email)}
                      />
                    }
                  </div>

                  {item.error && (
                    <div className="text-danger mt-1" style={{ fontSize: 11 }}>
                      {item.error}
                    </div>
                  )}
                </div>
              ))}
            </Form.Group>
          )}
        </Form.Group>
      </Offcanvas.Body>

      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}>
        {shareWith === "anyone" && (
          <Button
            onClick={shareGroupExternalUser}
            variant="outline-primary"
            style={{ fontSize: 13 }}
            className="rounded-1 py-1 px-3"
            title={Title}
            disabled={loader}
          >
            {Title}
          </Button>
        )}
        {shareWith === "member" && (
          <Button
            onClick={shareGroupInternalUser}
            variant="outline-primary"
            style={{ fontSize: 13 }}
            className="rounded-1 py-1 px-3"
            title={Title}
            disabled={loader}
          >
            {Title}
          </Button>
        )}
      </div>
    </Offcanvas>
  );
};

export default GroupShareWithMember;
